//# sourceMappingURL=info.mjs.map
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $a from "../../lustre/lustre/attribute.mjs";
import * as $el from "../../lustre/lustre/element.mjs";
import * as $s from "../../lustre/lustre/element/svg.mjs";
import { toList, List$Empty$const as $List$Empty$const } from "../gleam.mjs";

const indent_size = 46;

const v_break = 35;

function svg_link(url, text) {
  return $s.a(
    toList([
      $a.attribute("fill", "blue"),
      $a.attribute("text-decoration", "underline"),
      $a.href(url),
    ]),
    toList([$el.text(text)]),
  );
}

function nested_text(attrs, elements) {
  return $el.namespaced("http://www.w3.org/2000/svg", "text", attrs, elements);
}

function text_lines_with_indent(start, lines) {
  return $list.index_map(
    lines,
    (data, i) => {
      let indent = data[0];
      let line = data[1];
      let y_pos = start + i * v_break;
      let x_pos = indent * indent_size;
      return nested_text(
        toList([
          $a.attribute("x", $int.to_string(x_pos)),
          $a.attribute("y", $int.to_string(y_pos)),
        ]),
        line,
      );
    },
  );
}

export function view() {
  return text_lines_with_indent(
    30,
    toList([
      [0, toList([$el.text("Drew Olson")])],
      [0, toList([$el.text("Chicago, IL")])],
      [0, toList([$el.text("drew@drewolson.org")])],
      [0, $List$Empty$const],
      [0, toList([$el.text("Portfolio")])],
      [
        0,
        toList([
          $el.text("-> "),
          svg_link("https://github.com/drewolson", "github.com/drewolson"),
        ]),
      ],
      [
        0,
        toList([
          $el.text("-> "),
          svg_link("https://blog.drewolson.org", "blog.drewolson.org"),
        ]),
      ],
      [0, $List$Empty$const],
      [0, toList([$el.text("Work")])],
      [0, toList([$el.text("-> Distinguished Engineer")])],
      [1, toList([svg_link("https://pay.google.com/about", "Google")])],
    ]),
  );
}
